export const orderInfoAdapter = (data) => {
	return {
		info: data?.info?.pharmacy?.[0],
		type_retirement: data?.info.type_retirement
	};
};
